export * from './messages';
export * from './atoms';
export * from './molecules';
export * from './organisms';

import { FormAtoms } from './atoms';
import { FormMolecules } from './molecules';
import { FormOrganisms } from './organisms';

export const FormComponents = [
    ...FormAtoms,    
    ...FormMolecules,
    ...FormOrganisms
]